module.exports = __webpack_public_path__ + "static/media/Avatars_Other-03.bb8eb64e.png";